<template>

  <q-field
      class="mw-form-v2-input"
      :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"

      v-model="fieldValue"
      :label="field.layout_injected_label ? field.layout_injected_label : field.label"
      @focus="focus()"
      lazy-rules
      debounce="1000"
      :rules="field.required ? [ val => val && val.length > 0 || requiredText] : []"
      :hide-bottom-space="hide_bottom_space"
  >
    <template v-slot:control>
      <Autocomplete
          :options='{
                      componentRestrictions: { country: "us" }
                }'
          placeholder="" ref="google" v-model="fieldValue" class="q-field__native self-center full-width no-outline" @place_changed="setPlace"> </Autocomplete>
<!--      <div class="self-center full-width no-outline" tabindex="0">Field content</div>-->
    </template>
    <template v-slot:append>
      <q-icon name="s_public" />
    </template>
    <template v-slot:label>
      {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
    </template>
  </q-field>
</template>

<script>
import {mapFields} from "vuex-map-fields";
import {app} from '@/main'
import VueGoogleMaps from '@fawmi/vue-google-maps'

import Autocomplete from '@fawmi/vue-google-maps/src/components/autocomplete'
import {mapActions} from "vuex";
import OptionalLabel from "@/components/OptionalLabel";
import {Notify} from "quasar";

let imported = false;

export default {
  props: {
    modelValue: {},
    field:{},
    doNotCheckStateLicense: null,
    hide_bottom_space: null
  },
  data() {
    return {

    };
  },
  components: {Autocomplete, OptionalLabel},
  emits: ['update:modelValue', 'onAddressSelected'],
  methods: {
    ...mapActions({
      getLicenses: 'lo/licenses/default',
    }),
    ...mapActions({
      updateFieldValueByFieldType: 'values/list/updateFieldValueByFieldType'
    }),
    setPlace(place) {
      //console.log(place);
      const city = this.getComponentByType(place, 'locality');
      const state = this.getComponentByType(place, 'administrative_area_level_1', 'short_name');
      // const state_long = this.getComponentByType(place, 'administrative_area_level_1', 'long_name');
      const zipcode = this.getComponentByType(place, 'postal_code', 'short_name');
      const street_number = this.getComponentByType(place, 'street_number');
      const route = this.getComponentByType(place, 'route');
      let stateIsLicensed = false;
      let statesListAbbr = [];
      for (let item in this.licenses) {
        if(this.licenses[item].value === state) {
          stateIsLicensed = true;
        }
        statesListAbbr.push(this.licenses[item].value);
      }
      const statesString = statesListAbbr.join(",");
      if(!this.licenses || this.licenses.length === 0 ) {
        stateIsLicensed = true;
      }
      if(this.doNotCheckStateLicense !== false) {
        if (!stateIsLicensed && this.field.options.licenses_filter) {
          Notify.create({
            message: 'State ' + state + " is not licensed. Please use address in " + statesString,
            color: "purple"
          })
          this.fieldValue = "";
          this.$refs.google.$refs.input.value = "";
          return;
        }
      }

      let addressLine1 = '';
      if (street_number) {
        addressLine1 = street_number;
      }
      if (street_number && route) {
        addressLine1 = street_number + ' ' + route;
      }
      if (!street_number && route) {
        addressLine1 = route;
      }
      this.fieldValue = this.field.options.full_address ? place.formatted_address : addressLine1;
      this.$refs.google.$refs.input.value = this.field.options.full_address ? place.formatted_address : addressLine1;

      if(
          this.field.options.city
          || this.field.options.state
          || this.field.options.zipcode
      ) {
        if (city && this.field.options.city) {
          this.updateFieldValueByFieldType({form: this.form, type: this.field.options.city, fieldValue: city});
        }
        if (zipcode && this.field.options.zipcode) {
          this.updateFieldValueByFieldType({form: this.form, type: this.field.options.zipcode, fieldValue: zipcode});
        }
        if (state && this.field.options.state) {
          this.updateFieldValueByFieldType({form: this.form, type: this.field.options.state, fieldValue: state});
        }
      } else {
        if (city) {
          this.updateFieldValueByFieldType({form: this.form, type: 'location.city', fieldValue: city});
        }
        if (zipcode) {
          this.updateFieldValueByFieldType({form: this.form, type: 'location.zipcode', fieldValue: zipcode});
        }
        if (state) {
          this.updateFieldValueByFieldType({form: this.form, type: 'location.state', fieldValue: state});
        }
      }

      this.$emit('onAddressSelected', {
        address: addressLine1,
        city: city,
        state: state,
        zipcode: zipcode
      });

    },
    getComponentByType(address, type, field = 'long_name') {
      if (!type) {
        return null;
      }
      if (!address || !address.address_components || address.address_components.length === 0) {
        return null;
      }

      type = type.toLowerCase();

      for (const comp of address.address_components) {
        if (!comp.types || comp.types.length === 0) {
          continue;
        }

        if (comp.types.findIndex(x => x.toLowerCase() === type) > -1) {
          return comp[field];
        }
      }
      return null;
    },
    focus() {
      this.$refs.google.$refs.input.focus();
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings',
      form: 'form',
    }),
    ...mapFields('values/list', {
      fieldValues: 'fieldValues'
    }),
    ...mapFields('lo/licenses', {
      licenses: 'licenses'
    }),
    ...mapFields('lo/lo', {
      loan_officer_selected: 'loan_officer_selected',
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please type something';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  watch: {
    modelValue: function (value) {
      if(this.doNotCheckStateLicense) {
        this.$refs.google.$refs.input.value = value;
      }
    }
  },
  mounted() {
    if(!this.licenses) {
      this.getLicenses({loan_officer_selected: this.loan_officer_selected});
    }
    this.$refs.google.$refs.input.value = this.fieldValue;
    this.$refs.google.$refs.input.addEventListener("change", (e) => {
        this.fieldValue = e.target.value;
    });
  },
  setup () {
    if(!imported) {
      app.use(VueGoogleMaps, {
        load: {
          key: 'AIzaSyAgPQ05NdZH60Nh2Fg8bw-a0GYObzi3alI', //this.form.google_api_key,
          libraries: "places",
          language: 'en',
          componentRestrictions: { country: "us" }
        },
      })
      imported = true;
    }
  }
}
</script>
